import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className=" footer page-footer font-small py-0">
      <div className="container">
        <div className="row">
          <div className="col-md-4">
            <h5 className="text-dark">CultureCompass</h5>
            <p className="text-dark">Explore the cultures of Canada,<br />Venezuela, China, and the Philippines<br />with CultureCompass.</p>
          </div>
          <div className="col-md-4">
            <h5>Quick Links</h5>
            <ul className="list-unstyled text-dark">
              <li><Link to="/" className="text-dark">Home</Link></li>
              <li><Link to="/Surveys" className="text-dark">Surveys</Link></li>
              <li><Link to="/Scoreboard" className="text-dark">Scoreboard</Link></li>
            </ul>
          </div>
          <div className="col-md-4">
            <h5>Contact Information</h5>
            <ul className="list-unstyled text-dark">
              <li>Email: example@example.com</li>
              <li>Phone: +1234567890</li>
              <li>Address: 123 Street, City, Country</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="footer-bottom  text-dark py-2 bg-success">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <p style={{ color: '#ffffff' }}>&copy; 2024 CultureCompass. All rights reserved.</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
